import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SERVER_FULL_PATH } from "../../helpers/constants/url";

// initialize an empty api service that we'll inject endpoints into later as needed
const baseApi = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: SERVER_FULL_PATH,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token || localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `JWT ${token}`);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
  tagTypes: ["User", "Me", "Event", "PackagePlan", "Photo", "AI"],
});

export default baseApi;
